export enum AnalyticsStatusEnum {
  PENDING = 'pending',
  GENERATING = 'generating',
  PREVIEW = 'preview',
  GENERATED = 'generated',
  FAILED = 'failed',
}
